import React from 'react';
import { Box } from '@mui/material';

const MONO = "'IBM Plex Mono', monospace";

// Kicker: "// label" in teal above section headings.
// variant: 'pill' (rounded border) | 'plain' (just text)
export default function Kicker({ children, variant = 'pill', light = false, sx = {} }) {
  const color = light ? '#0d47a1' : '#2dd4bf';

  if (variant === 'pill') {
    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '9px',
          fontFamily: MONO,
          fontSize: '12px',
          letterSpacing: '.18em',
          textTransform: 'uppercase',
          color,
          border: `1px solid ${light ? 'rgba(13,71,161,.35)' : 'rgba(45,212,191,.35)'}`,
          borderRadius: '999px',
          px: '13px',
          py: '6px',
          mb: '24px',
          whiteSpace: 'nowrap',
          ...sx,
        }}
      >
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: color,
            flexShrink: 0,
            animation: 'pulseDot 1.8s ease-in-out infinite',
            '@keyframes pulseDot': { '0%,100%': { opacity: .35 }, '50%': { opacity: 1 } },
          }}
        />
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        fontFamily: MONO,
        fontSize: '12px',
        letterSpacing: '.16em',
        textTransform: 'uppercase',
        color,
        mb: '10px',
        ...sx,
      }}
    >
      {`// ${children}`}
    </Box>
  );
}
